import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDollarsWithOptionalCents } from '../../../../../../utils/formatting';
import s from './MinimumOffer.scss';
const MinimumOffer = ({ value })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['label']
    }, t('sidebar.exclusives.minimumOffer')), /*#__PURE__*/ React.createElement("div", {
        className: s['value']
    }, formatDollarsWithOptionalCents(value)));
};
MinimumOffer.displayName = 'MinimumOffer';
export default MinimumOffer;

//# sourceMappingURL=MinimumOffer.js.map